import type { PropsWithChildren } from "react";
import { Helmet } from "react-helmet-async";

type PageContainerProps = PropsWithChildren & {
	description?: string;
	title?: string;
};

export const PageContainer = ({
	title,
	description,
	children,
}: PageContainerProps) => (
	<>
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
		</Helmet>
		{children}
	</>
);
